import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import _Object$assign from '@babel/runtime-corejs3/core-js-stable/object/assign';
import { c as classNames } from '../../shared/bind-a2a3a613.js';
import { s as styles, T as TabTitle, a as Tab } from '../../shared/Tab-9c42c804.js';
import { Divider } from '../Divider/Divider.js';
import { jsx, jsxs } from 'react/jsx-runtime';

/* ---------- String-union sources of truth ---------- */
var TABS_WIDTH_VALUES = ['parent'];
var TABS_STYLING_VALUES = ['wide'];
/* ---------- Back-compat shim (deprecated) ---------- */
var TABS_WIDTH = {
  Parent: 'parent'
};
var TABS_STYLING = {
  Wide: 'wide'
};
var cssClasses = classNames.bind(styles);
var TabsBase = function TabsBase(_ref) {
  var _ref$items = _ref.items,
    items = _ref$items === void 0 ? [] : _ref$items,
    _ref$role = _ref.role,
    role = _ref$role === void 0 ? 'tablist' : _ref$role,
    activeItemId = _ref.activeItemId,
    width = _ref.width,
    styling = _ref.styling,
    onClick = _ref.onClick,
    testId = _ref.testId,
    divider = _ref.divider;
  var tabsClasses = cssClasses('tabs', width, styling);
  var getTabTestId = function getTabTestId(id) {
    if (testId) {
      var _context, _context2;
      return activeItemId === id ? _concatInstanceProperty(_context = "".concat(testId, "-")).call(_context, id, "--active") : _concatInstanceProperty(_context2 = "".concat(testId, "-")).call(_context2, id);
    }
    return undefined;
  };
  var tabItems = _mapInstanceProperty(items).call(items, function (item) {
    return /*#__PURE__*/jsx(Tab, {
      item: item,
      role: role === 'tablist' ? 'tab' : 'menuitem',
      onClick: onClick,
      isActive: activeItemId === item.id,
      testId: getTabTestId(item.id)
    }, item.id);
  });
  return /*#__PURE__*/jsxs("div", {
    className: tabsClasses,
    "data-testid": testId,
    children: [/*#__PURE__*/jsx("ul", {
      className: styles.content,
      role: role,
      children: tabItems
    }), divider ? /*#__PURE__*/jsx(Divider, {
      className: styles.divider
    }) : null]
  });
};

/** The public component type: a React component value that also has deprecated statics */

/** Exported component: arrow fn + statics, deprecations intact, docgen-friendly */
var Tabs = _Object$assign(TabsBase, {
  /**
   * @deprecated Use string literals instead: 'parent'
   */
  Width: TABS_WIDTH,
  /**
   * @deprecated Use string literals instead: 'wide'
   */
  Styling: TABS_STYLING,
  TabTitle: TabTitle
});

export { TABS_STYLING, TABS_STYLING_VALUES, TABS_WIDTH, TABS_WIDTH_VALUES, Tabs, Tabs as default };
//# sourceMappingURL=Tabs.js.map
